import React from 'react';
import PropTypes from 'prop-types';
import BulletPointList from '../../common/utility/BulletPointList';
import { getMultilineText } from '../../../../../general/js/utils';

function LeaveOneClubModalBody({
    leaveTheOneClubDialogBoxTitle,
    leaveTheOneClubDialogBoxMessage,
    leaveOneClubDialogBoxCheckText,
    leaveOneClubCheck,
    onLeaveOneClubClick
}) {
    const leaveTheOneClubDialogBoxMessageSplit = getMultilineText(leaveTheOneClubDialogBoxMessage);
    return (
        <div>
            <h2 className="title field-header-title">{leaveTheOneClubDialogBoxTitle}</h2>
            <div className='fs-14 field-header-text'>
                <BulletPointList listItems={leaveTheOneClubDialogBoxMessageSplit}></BulletPointList>
            </div>
            <div
                className={'form-field auto-mt-xs leaveOneClubCheck-field'}>
                <label className="form-switch">
                    <input
                        type='checkbox'
                        className='form-checkbox__checkbox visually-hidden'
                        name={'leaveOneClubCheck'}
                        id={'leaveOneClubCheck'}
                        onChange={onLeaveOneClubClick}
                        checked={leaveOneClubCheck}
                    /><i></i>{leaveOneClubDialogBoxCheckText}

                </label></div>
            <br />
        </div>
    );
}

LeaveOneClubModalBody.propTypes = {
    leaveTheOneClubDialogBoxTitle: PropTypes.string.isRequired,
    leaveTheOneClubDialogBoxMessage: PropTypes.string.isRequired,
    leaveOneClubDialogBoxCheckText: PropTypes.string.isRequired,
    leaveOneClubCheck: PropTypes.bool.isRequired,
    onLeaveOneClubClick: PropTypes.func.isRequired,
};

export default LeaveOneClubModalBody;
